import React, { useState } from 'react';
import './ProfessionalExperience.css';
import shelterLogo from '../assets/shelter.png';
import mizzouLogo from '../assets/mizzou.png'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';

const ProfessionalExperience = () => {
  const [activeCard, setActiveCard] = useState(null);

  const toggleCard = (index) => {
    // If the same card is clicked, we collapse it, otherwise we expand it.
    setActiveCard(activeCard === index ? null : index);
  };

  return (
    <section id="professional-experience" className="professional-experience-section">
      <h2 className="professional-title">Professional Experience</h2>
      <div className="experience-container">
        {/* Shelter Insurance */}
        <div className={`experience-card ${activeCard === 0 ? 'active' : ''}`}>
          <div className="experience-header" onClick={() => toggleCard(0)}>
            <h3>Software Engineer @ Shelter Insurance</h3>
            <span>November 2023 - Present</span>
            <button className="toggle-button">{activeCard === 0 ? (<FontAwesomeIcon icon={faAngleDown} />) : '+'}</button>
          </div>
          <div className={`experience-details ${activeCard === 0 ? 'show' : ''}`}>
            <img src={shelterLogo} alt="Shelter Insurance" className="company-logo" />
            <div className="details-content">
              <div className="location">
                <FontAwesomeIcon icon={faLocationDot} className="location-icon" />
                <span>Remote, Columbia, MO</span>
              </div>
              <p>
                Developed and maintained Java and SQL-based applications while adhering to the Scrum framework. Worked collaboratively to complete sprints on time and participated in peer-programming to fix bugs and perform dev testing.
              </p>
              <div className="tools">
                <span>Java</span>
                <span>SQL</span>
                <span>Jira</span>
                <span>Gitbucket</span>
                <span>Jenkins</span>
                <span>Postman</span>
                <span>SQuirreL</span>
                <span>Microsoft Teams</span>
              </div>
            </div>
          </div>
        </div>

        {/* Mizzou Division of IT */}
        <div className={`experience-card ${activeCard === 1 ? 'active' : ''}`}>
          <div className="experience-header" onClick={() => toggleCard(1)}>
            <h3>Student Assistant @ Mizzou Division of IT</h3>
            <span>June 2023 - November 2023</span>
            <button className="toggle-button">{activeCard === 1 ? '-' : '+'}</button>
          </div>
          <div className={`experience-details ${activeCard === 1 ? 'show' : ''}`}>
            <img src={mizzouLogo} alt="Mizzou Division of IT" className="company-logo" />
            <div className="details-content">
              <div className="location">
                <FontAwesomeIcon icon={faLocationDot} className="location-icon" />
                <span>Columbia, MO</span>
              </div>
              <p>
                Managed building operations, processed employee onboarding, and coordinated meeting spaces. Provided support by greeting guests and answering inquiries.
              </p>
              <div className="tools">
                <span>Office Coordination</span>
                <span>Onboarding</span>
                <span>Customer Service</span>
              </div>
            </div>
          </div>
        </div>

        {/* Education*/}
        <div className={`experience-card ${activeCard === 2 ? 'active' : ''}`}>
          <div className="experience-header" onClick={() => toggleCard(2)}>
            <h3>Student @ University of Missouri - Columbia</h3>
            <span>Expected Graduation: May 2025</span>
            <button className="toggle-button">{activeCard === 2 ? (<FontAwesomeIcon icon={faAngleDown} />) : '+'}</button>
          </div>
          <div className={`experience-details ${activeCard === 2 ? 'show' : ''}`}>
            <img src={mizzouLogo} alt="Mizzou" className="company-logo" />
            <div className="details-content">
              <div className="location">
                <FontAwesomeIcon icon={faLocationDot} className="location-icon" />
                <span>Columbia, MO</span>
              </div>
              <p>
                Bachelors of Science in Computer Science with a minor in Mathematics
              </p>
              {/* <div className="tools">
                <span>Java</span>
                <span>SQL</span>
                <span>Jira</span>
                <span>Gitbucket</span>
                <span>Jenkins</span>
                <span>Postman</span>
                <span>SQuirreL</span>
                <span>Microsoft Teams</span>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProfessionalExperience;
